import { useEffect } from 'react';
import type React from 'react';

import { Button, Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';
import { PlayArrowIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { EmbeddedVideo } from '#src/app/shared/components/embeddedMediaSunrise';

import { useHeroVideoButton } from './hooks';

export const PageHeading: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { embedHtml, modalIsOpen, shouldShowVideoOnLoad },
		actions: { handleButtonClick, handleCloseModal, showVideo },
	} = useHeroVideoButton();
	useEffect(() => {
		if (shouldShowVideoOnLoad) {
			showVideo();
		}
	}, [shouldShowVideoOnLoad, showVideo]);

	return (
		<div className="container mb-10 pt-8">
			<Text variant="heading" size="x-large" as="h1" className="mb-6 capitalize">
				<Translate value="fe.pages.impact.title" />
			</Text>
			<Button
				className="mt-4"
				variant="secondary"
				onClick={handleButtonClick}
				leadingIcon={<PlayArrowIcon />}
				data-qa="heading-video"
			>
				<Translate value="fe.pages.impact.video_btn" />
			</Button>
			<Modal
				onClose={() => {}}
				closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
				size="large"
				isOpen={modalIsOpen}
				onOpenChange={handleCloseModal}
			>
				<ModalHeader />
				<ModalBody>
					<div className="w-full">
						<EmbeddedVideo className="mt-6" aspectRatio="16/9" embedHtml={embedHtml}></EmbeddedVideo>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};
